import { OfferDetailScreen } from '@fhs/loyalty';
import { withStoreSelected } from '@fhs-legacy/frontend/src/components/store-selected';

export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

function OfferDetails() {
  return <OfferDetailScreen />;
}

export default withStoreSelected(OfferDetails);
